import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=790de60b&scoped=true&"
import script from "./AppCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AppCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=790de60b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790de60b",
  null
  
)

export default component.exports